@if (!passwordRequired) {
  <div>
    <app-ca-header></app-ca-header>
    @if (!isExpired) {
      <div>
        @if (!orderAccepted) {
          <div>
            <app-customer-acknowledgement-form
              #customerAcknowledgement
              (downloadPdf)="downloadPdf($event)"
              [ridPresent]="passwordRequired"
              [caId]="caId"
              [acceptString]="acceptString"
              [channelCode]="channelCode"
              >
            </app-customer-acknowledgement-form>
          </div>
        }
      </div>
    }
    @if (isExpired) {
      <div>
        <app-order-expired-page> </app-order-expired-page>
      </div>
    }
    @if (!orderAccepted && !isExpired) {
      <app-ca-footer></app-ca-footer>
    }
  </div>
}

<ng-template #content let-modal>
  <div class="modal-content">
    <form (ngSubmit)="onSubmit()" [formGroup]="passwordForm">
      <div class="modal-body">

        <div class="mb-3">
          <span class="modal-text"
            >Please key in your password. The last 6-digit of your ID, example
            for IC no. xxxxxx-07-1234, key in 071234</span
            >
            <div class="input-group" style="padding-top: 16px">
              <input
                class="form-control"
                name="password"
                type="password"
                required
                formControlName="password"
                maxlength="6"
                minlength="6"
                />
              </div>
            </div>
            <!-- <div class="input-group-invalid">
            <div *ngIf="passwordForm.invalid && (passwordForm.dirty || passwordForm.touched)">
              <span>Password is required.</span>
            </div>
          </div> -->

        </div>

        <div class="modal-footer">
          <button
            type="submit"
            [disabled]="passwordForm.invalid"
            class="btn btn-success"
            >
            Submit
          </button>
        </div>
      </form>
    </div>
  </ng-template>